//import React from "react";
import React, {useState,useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';

// react component for creating dynamic tables
import ReactTable from "react-table";

// @material-ui/core components
// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";
import Search from "@material-ui/icons/Search";
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
// icons
import Check from "@material-ui/icons/Check";
import LoadingIcon from "@material-ui/icons/Cached";
import "beaktShared/components/CustomInput/rotate.css";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";import Clearfix from "beaktShared/components/Clearfix/Clearfix.js";
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";

// services
import { UseGetApiSimple, UsePostApi, UsePutApi, } from "beaktShared/services/crudeApiService";
import { SessionContext } from "beaktShared/services/session";
import Avaliacao from "beaktClinic/views/Avaliacao/Avaliacao.js";
import { setAvaliacaoConsultaCookie } from "beaktClinic/services/avaliacaoCookie";
import { formateDateandTime } from "beaktShared/helpers/masks";


// styles
import styles from "assets/jss/material-dashboard-pro-react/views/crudeStyle.js";
import { noCaseSensitive } from "beaktShared/helpers/extras";
const useStyles = makeStyles(styles);

export default function GestaoClienteAvaliacao({clienteId, estabelecimentoId}) {
    
    const { t } = useTranslation();
    const session = useContext(SessionContext);

    const [showFormView, setshowFormView] = React.useState(false);
    const [item, setItem] = useState({});
    const [loadingForm, setLoadingForm] = React.useState(false);

    const [list, setlist, isErrorGetList] = React.useState([]);
    const [isLoadingList, setisLoadingList] = React.useState(false);

    const [notification, setNotification] = React.useState({
        show:false,
        color:'info',
        message:''
    });

    const showNotification = (message,color) => { 
        setNotification({
        show:true,
        color:color,
        message:message      
        });
        setTimeout(function() {
        setNotification({show:false});
        }, 6000);       
    };
    
    
    useEffect(() => {
        LoadAvaliacoesCliente();
    }, []);

    const handleView = (resetItem) => {
        if (resetItem)
            setItem({});
        let show = showFormView === true ? false : true;
        setshowFormView(show);
    }; 

    const LoadAvaliacoesCliente =() =>{
        
        let endPoint = "clientes/AvaliacoesCliente/"+ clienteId + "/" + estabelecimentoId;
        UseGetApiSimple(endPoint).then(result=>{       
            if(result.status !== 200)
            {                                      
                showNotification(result.message, 'danger');
            }
            setlist(result.data);
            
        });
    };

    const handleEdit = dados => {                                      
        let avaliacao = {
            'avaliacaoId': dados.avaliacaoId,
            'cliente' : 
            {
                'cpf' : dados.cliente.cpf,
                'nome' : dados.cliente.nome,
                'email' : dados.cliente.email,
                'celular' : dados.cliente.celular,
                'sexo' : dados.cliente.sexo,
                'atendente' : dados.cliente.cpf,
                'estabelecimentoClientes' : [{
                    'estabelecimentoId' : session.estabelecimentoId
                }]
            },
            'kg': dados.peso,
            'altura': dados.altura,
            'idade': dados.idade,
            'quadril': dados.quadril,
            'cintura': dados.cintura,
            'peso5anos': dados.peso5anos,
            'gordura': dados.percentualGordura,
            'sedentarismo': dados.nivel  
        }                           

         setAvaliacaoConsultaCookie(avaliacao);
         setItem(dados);
         handleView(false);
    };

    const columnsProp = [{
        Styles:'text-align:right',
        Header: t('label.date'), 
        accessor: "dataCadastro",
        Cell : (row)=>{
            let custom_date = formateDateandTime(row.original.dataCadastro);
            
            return <span>{custom_date}</span>
        }
    },
    {
        styles:{textAlign:'right'},
        Header: t('label.name'),
        accessor: "cliente.nome"
    }]
    const columnsAcao = [
    {
        Header: t('label.actions'),
        Cell: row => (
            <div className="actions-right">
                <Link to="/adminclinic/avaliacao" >
                    <Button color="transparent" 
                            onClick={() => handleEdit(row.original)}
                            style={{ border: '2px solid #562682', color: '#562682', padding: '0px 6px', height: '40px', textAlign:'center'}}>
                            <Tooltip title={t('label.detail')} id="tooltip-top" placement="top" classes={{ tooltip: classes.tooltip }} >
                            <Search />
                        </Tooltip>
                    </Button>
                </Link>
            </div>

        ),
        sortable: false,
        filterable: false
    }
    ];
    const columns = [...columnsProp, ...columnsAcao]
    const customProps = { id: 'GestaoClienteAvaliacao' };

    const classes = useStyles();

    return (
        <div >
            {showFormView && 
                                        <Avaliacao item={item} handleView={handleView} loading={loadingForm} />} 
                        <GridContainer>
                            <GridItem xs={12}>
                                <Card>
                                    <CardHeader color="primary" icon>
                                        <CardIcon color="primary">
                                            <Assignment />
                                        </CardIcon>
                                        <h4 className={classes.cardIconTitle}>{t('sidebar.client_avaliation')}</h4>
                                    </CardHeader>
                                    <CardBody>                  
                                        {isErrorGetList && <div>{t('error_message.loading_error')}...</div>}
                                        <ReactTable
                                            loading={isLoadingList}
                                            data={list}
                                            columns={columns}
                                            filterable={false}
                                            defaultFilterMethod = {noCaseSensitive}
                                            defaultPageSize={10}
                                            minRows={5}
                                            showPaginationBottom={true}
                                            className="-striped -highlight"
                                            previousText={t('button.previous')}
                                            nextText={t('button.next')}
                                            loadingText={t('label.loading')+"..."}
                                            noDataText={t('information_message.no_records_found')+"!"}
                                            pageText={t('label.page')}
                                            ofText={t('label.of')}
                                            rowsText={t('label.rows')}
                                            getProps={() => customProps}
                                        />
                                    </CardBody>
                                </Card>
                            </GridItem>
                        </GridContainer>
        </div>
    );
}